import React, { useEffect, useState } from 'react';
import WysiwygEditor from '../WysiwygEditor';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../Reports.redux';
import { useParams } from '@tanstack/react-router';
import useNavigationWarning from 'hooks/useNavigationWarning';
import api from 'api';
import { Box, TextField } from '@mui/material';

const EditTemplate = () => {
    const dispatch = useDispatch(),
        { templateID } = useParams({ from: '/reports/edit-layout/$templateID' }),
        template = useSelector((state) => state.reports.template),
        editorContent = useSelector((state) => state.reports.editorContent),
        templates = useSelector((state) => state.reports.editorTemplates),
        autofill = useSelector((state) => state.reports.autofill),
        firstLoad = useSelector((state) => state.reports.firstLoad),
        editorIsDirty = useSelector((state) => state.reports.editorIsDirty),
        [saving, setSaving] = useState(false),
        [Prompt, setDirty, setClean] = useNavigationWarning();

    const handleChange = (newValue, editor) => {
        dispatch(actions.setState({ editorContent: newValue, editorIsDirty: !firstLoad, firstLoad: false }));
    };

    const handleChangeTitle = (e) => {
        dispatch(actions.setSubState('template', { template_name: e.target.value }, true));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await api.put('/reports/templates', {
                template_id: template.template_id,
                template_config: {
                    main: editorContent,
                },
                template_name: template.template_name,
            });

            dispatch(actions.setState({ editorIsDirty: false }));
        } catch (err) {
            console.error(err);
        }

        setSaving(false);
    };

    // Load template on initial load
    useEffect(() => {
        dispatch(actions.load_template(templateID));
    }, [dispatch, templateID]);

    // Reset state when leaving the page
    useEffect(() => {
        // do nothing
        return () => dispatch(actions.resetAll());
    }, [dispatch]);

    // Set editor dirty state
    useEffect(() => {
        editorIsDirty ? setDirty() : setClean();
    }, [editorIsDirty, setClean, setDirty]);

    // TinyMCE isn't great at updating with new props.
    // Don't render the editor until we've fetched everything.
    if (!template.template_config) {
        return null;
    }

    return (
        <div>
            <Box sx={{ width: '100%' }}>
                <TextField
                    label={template.template_name ? 'Layout Title' : undefined}
                    placeholder="Layout Title"
                    value={template.template_name ?? ''}
                    onChange={handleChangeTitle}
                    sx={{
                        marginBottom: 1,
                        width: '100%',
                        backgroundColor: '#ffffff',
                        '& .MuiInputBase-input': {
                            fontSize: '1.5rem', // text inside field
                        },
                    }}
                />
            </Box>

            <WysiwygEditor
                value={editorContent}
                handleSave={handleSave}
                disableSave={saving || !template.template_name}
                onChange={handleChange}
                templates={templates}
                showReplacementButton={false}
                autofill={autofill}
            />

            {Prompt}
        </div>
    );
};

export default EditTemplate;
